import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import PropTypes from "prop-types";
import { FaShieldAlt } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";
import { GiMoneyStack } from "react-icons/gi";
import { GiPodiumWinner } from "react-icons/gi";
import { MdSchool } from "react-icons/md";
import { FaMapMarkerAlt } from "react-icons/fa";
import Button from "./Button";

const reasons = [
	{
		title: "Top Safety Precautions",
		description:
			"We prioritize your safety with every lesson, ensuring a secure and comfortable driving experience during our driving lessons in Canberra.",
		icon: FaShieldAlt,
	},
	{
		title: "Flexible Scheduling Options",
		description:
			"Take control of your learning schedule with our flexible lesson timings, tailored to fit around your lifestyle. Choose drivers training classes that suit you best.",
		icon: FaCalendarAlt,
	},
	{
		title: "Affordable Plans",
		description:
			"We provide affordable driving lessons designed to offer high-quality training without exceeding your budget. Quality instruction at great prices.",
		icon: GiMoneyStack,
	},
	{
		title: "Supportive Instructors",
		description:
			"Our driving instructors are experienced and supportive, ensuring you receive the best guidance and encouragement throughout your driver's training classes.",
		icon: GiPodiumWinner,
	},
	{
		title: "Customized Lesson Plans",
		description:
			"Every lesson is tailored to your specific needs, ensuring that your driver's training classes are focused on making you a confident, safe and skilled driver.",
		icon: MdSchool,
	},
	{
		title: "Easily Accessible Location",
		description:
			"Serving Canberra and surrounding areas, including Queanbeyan, we offer convenient lesson locations, making it easier than ever to get the training you need.",
		icon: FaMapMarkerAlt,
	},
];

const cardVariants = {
	hidden: { opacity: 0, y: 80 },
	visible: { opacity: 1, y: -10, transition: { duration: 1 } },
};

const ReasonCard = ({ reason }) => {
	const [ref, inView] = useInView({
		triggerOnce: true,
		threshold: 0.4, // Adjust threshold to 60%
	});

	return (
		<motion.div
			ref={ref}
			initial="hidden"
			animate={inView ? "visible" : "hidden"}
			variants={cardVariants}
			className="flex flex-col group items-center p-2 gap-6 rounded-lg font-poppins"
		>
			{/* <div className="bg-steerOrange lg:p-4 p-2 w-max rounded-full hidden lg:flex items-center justify-center">
				<reason.icon className="text-2xl text-white" />
			</div> */}
			<div className="flex flex-col space-y-4 font-generalSans">
				<div className="flex items-center gap-4">
					<div className="bg-white/60 backdrop-blur-md lg:p-4 p-2 w-max rounded-full flex items-center justify-center text-center">
						<reason.icon className="text-2xl text-steerOrange" />
					</div>
					<h2 className="font-semibold lg:text-xl text-lg text-steerBlack dark:text-white cursor-default text-center">
						{reason.title}
					</h2>
				</div>
				<p className="font-light text-sm xl:lg:text-sm cursor-default">
					{reason.description}
				</p>
			</div>
		</motion.div>
	);
};

ReasonCard.propTypes = {
	reason: PropTypes.shape({
		title: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		icon: PropTypes.elementType.isRequired,
	}).isRequired,
};

function WhySteerSmart() {
	return (
		<div className="flex flex-col justify-center items-center gap-12 lg:p-12 px-2 md:px-0">
			{/* <div className="flex-2 rounded-xl lg:w-3/5 overflow-hidden">
				<img
					src="/images/209477.webp"
					alt="Why Steer Smart"
					className="w-full h-auto object-cover"
				/>
			</div> */}
			<div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-x-32 gap-y-12 justify-center">
				{reasons.map((reason, index) => (
					<ReasonCard key={index} reason={reason} />
				))}
			</div>

			<Button
				buttonName="Book Now"
				buttonLink="/packages"
				buttonStyle="secondary"
			/>
		</div>
	);
}

export default WhySteerSmart;
